import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

import { NORESULTS_RECID } from "../config"

export default function NoResults() {

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ NORESULTS_RECID ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    return (
        <div class="nosto_element py-8" id={NORESULTS_RECID} />
    )
}
